import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Link,
} from 'react-router-dom';

import {
  AppBar,
  Toolbar,
  Typography,
  Chip,
  Dialog,
  IconButton,
  Hidden,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import MenuOutlined from '@material-ui/icons/MenuOutlined';

import LoginModal from '../../auth/components/LoginModal';
import CommonNavItems from '../components/CommonNavItems';
import CommonMobileNavItems from '../components/CommonMobileNavItems';

import * as authActions from '../../auth/actions';
import classes from '../../css/getCSS';
import '../../css/main.css';

import { getLogo } from '../../util';
import * as constants from "../../config/constants";


class Navbar extends Component {
  state = {
    loginModalOpen: false,
    mobileMenuOpen: false,
  }

  componentWillUnmount() {
    this.props.onUnmount();
  }

  handleClickOpen = () => {
    this.setState({
      loginModalOpen: true,
    });
  }

  handleClose = () => {
    this.setState({
      loginModalOpen: false,
    });
  }

  openMobileMenu = () => {
    this.setState({
      mobileMenuOpen: true,
    });
  }

  closeMobileMenu = () => {
    this.setState({
      mobileMenuOpen: false,
    });
  }

  render() {
    const logo = getLogo();

    const mobileDialog = (
      <Dialog
        fullScreen
        open={this.state.mobileMenuOpen}
        onClose={this.closeMobileMenu}
        classes={{
          paper: classes.dialogCard,
        }}
      >
        <AppBar style={{ position: 'relative' }}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.grow}>Menu</Typography>
            <IconButton color="inherit" onClick={this.closeMobileMenu} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <CommonMobileNavItems handleClickOpen={this.handleClickOpen} displayLogin={true} />
      </Dialog>
    );

    const classNames = [classes.mainNavbar];
    if (this.props.homeNavbar) {
      classNames.push(classes.homeNavbar);
    }
    if (this.props.solidNavbar) {
      const index = classNames.indexOf(classes.homeNavbar);
      if (index > -1) {
        classNames.splice(index, 1);
      }
    }

    let commonNavItems = <CommonNavItems/>
    let loginMenu = (
      <React.Fragment>
        <Hidden smDown>
          <Chip label="LOGIN" className={classes.loginButton} clickable variant="outlined" color="default"
                onClick={this.handleClickOpen}/>
        </Hidden>
        <Hidden mdUp>
          <IconButton
            className={classes.iconMenuButton}
            onClick={this.openMobileMenu}
          >
            <MenuOutlined/>
          </IconButton>
        </Hidden>
      </React.Fragment>
    )

    if (this.props.notLayoutView){
      commonNavItems = null
      loginMenu = null
    }

    const content = (
      <div className={classes.navWrapper}>
        <AppBar className={classNames.join(' ')} elevation={0}>
          <Toolbar>

              <Typography variant="title" color="inherit" className={classes.grow}>
                  <Link to="/" className={classes.linkDeCSS}>
                      <div>
                          <img src={logo} alt="anjal" className={classes.navLogo}/>
                          <span className={classes.stateName}>
                              {(window.location.host === constants.SAURASHTRA1_SITE_HOST) && <span>Saurashtra1 Bureau</span>}
                              {(window.location.host === constants.SAURASHTRA2_SITE_HOST) && <span>Saurashtra2 Bureau</span>}
                              {(window.location.host === constants.SAURASHTRA3_SITE_HOST) && <span>Saurashtra3 Bureau</span>}
                              {(window.location.host === constants.SAURASHTRA4_SITE_HOST) && <span>Saurashtra4 Bureau</span>}
                              {(window.location.host === constants.KUTCH_HOST) && <span>Kutch Bureau</span>}
                              {(window.location.host === constants.MUMBAI_SITE_HOST) && <span>Mumbai Bureau</span>}
                              {(window.location.host === constants.MAHARASHTRA_SITE_HOST) && <span>Maharastra Bureau</span>}
                              {(window.location.host === constants.EASTINDIA_SITE_HOST)  && <span>East India Bureau</span>}
                              {(window.location.host === constants.NORTHINDIA_SITE_HOST) && <span>North India Bureau</span>}
                              {(window.location.host === constants.NORTHGUJARAT_SITE_HOST) && <span>North Gujarat Bureau</span>}
                              {(window.location.host === constants.SOUTHGUJARAT_SITE_HOST) && <span>South Gujarat Bureau</span>}
                              {(window.location.host === constants.SOUTHINDIA_SITE_HOST) && <span>South India Bureau</span>}
                              {(window.location.host === constants.CENTRALGUJARAT_SITE_HOST) && <span>Central Gujarat Bureau</span>}
                              {(window.location.host === constants.VIDARBHA_SITE_HOST) && <span>Vidarbha Bureau</span>}
                              {(window.location.host === constants.CENTRAL_INDIA_SITE_HOST) && <span>Central India Bureau</span>}
                              {(window.location.host === constants.EUROPE_SITE_HOST) && <span>Europe Bureau</span>}
                              {(window.location.host === constants.GCC_SITE_HOST) && <span>GCC Bureau</span>}
                              {(window.location.host === constants.USA_SITE_HOST) && <span>USA Bureau</span>}
                              {(window.location.host === constants.AFRICA_SITE_HOST) && <span>Africa Bureau</span>}
                              {(window.location.host === constants.TANZANIA_SITE_HOST) && <span>Tanzania Bureau</span>}
                              {(window.location.host === constants.CANADA_SITE_HOST) && <span>Canada Bureau</span>}
                              {(window.location.host === constants.KENYA_SITE_HOST) && <span>Kenya Bureau</span>}
                              {(window.location.host === constants.UGANDA_SITE_HOST) && <span>Uganda Bureau</span>}
                              {(window.location.host === constants.AUSTRALIA_SITE_HOST) && <span>Australia Bureau</span>}
                              {(window.location.host === constants.NZFIJI_SITE_HOST) && <span>New Zealand and Fiji Bureau</span>}
                          </span>
                      </div>
                  </Link>
              </Typography>
              {commonNavItems}
              {loginMenu}
                    </Toolbar>
                </AppBar>
                <LoginModal
                    loginModalOpen={this.state.loginModalOpen}
                    handleClose={this.handleClose}
                    navigateToLogin={this.navigateToLogin}
                />
                {mobileDialog}
            </div>
        );
        return content;
    }
}

const mapStateToProps = (state) => {
  return {
    site: state.common.site,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUnmount: () => dispatch(authActions.onUnmount()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));



// WEBPACK FOOTER //
// ./src/common/containers/Navbar.js